import { render, staticRenderFns } from "./PrivateReservationFormCard.vue?vue&type=template&id=62999b57&scoped=true&"
import script from "./PrivateReservationFormCard.vue?vue&type=script&lang=js&"
export * from "./PrivateReservationFormCard.vue?vue&type=script&lang=js&"
import style0 from "./PrivateReservationFormCard.vue?vue&type=style&index=0&id=62999b57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62999b57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VRow,VTextarea})
